





















































import { Component, Mixins, Emit } from "vue-property-decorator";
import { Size } from "../../../../base/domain/drawing";
import {
  HeaderPane,
  RightSidePane,
  MenuPane,
  NavigationPane,
} from "../../../../base/components/panes";
import { CacheableComponent } from "../../../../base/components/system";
import { ModelEditableMixin, TabContainableMixin } from "../../../../base/components/system/mixins";
import { TabSelector } from "../../../../base/components/system/selectors";
import { IConfiguration } from "../../../domain/configuration";
import {
  FormatMultiPageSelector,
  FormatPageEditor,
  QuestionnaireFormatPageEditor,
  FormatToolContainer,
  FormatPageEditorMenuContainer,
  FormatEditMenuContainer,
  FormatEditNavigationContainer,
  CommonComponentsContainer,
} from "./contents";
import { FormatPropertyEditTool } from "./contents/tools";
import { FormatStructureEditableMixin } from "./mixins";
import { FormatStructureEditor } from "../../../domain/editableFormat";

interface ITabDefinition {
  name: string;
  title: string;
  description: string;
}

@Component({
  components: {
    HeaderPane,
    RightSidePane,
    MenuPane,
    NavigationPane,
    TabSelector,
    CacheableComponent,
    FormatPropertyEditTool,
    FormatMultiPageSelector,
    FormatPageEditor,
    QuestionnaireFormatPageEditor,
    FormatToolContainer,
    FormatPageEditorMenuContainer,
    FormatEditMenuContainer,
    FormatEditNavigationContainer,
    CommonComponentsContainer,
  },
})
export default class FormatEditor extends Mixins(ModelEditableMixin, TabContainableMixin, FormatStructureEditableMixin) {
  @Emit()
  formatRegistered(id: number, destinationRoute: any, isTemporary: boolean): any {}

  $configuration!: IConfiguration;

  static readonly Tabs = {
    format: {
      name: "format",
      title: "フォーマット属性",
      description: "フォーマット属性を編集します。",
    },
    pageList: {
      name: "pageList",
      title: "ページ一覧",
      description: "フォーマットのページを一覧表示します。各ページのプロパティの編集やページの追加/削除/並べ替えができます。",
    },
    pageLayout: {
      name: "pageLayout",
      title: "ページレイアウト",
      description: "現在ページのオブジェクトのレイアウトやプロパティを編集します。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly formatTab: ITabDefinition = FormatEditor.Tabs.format;
  readonly pageListTab: ITabDefinition = FormatEditor.Tabs.pageList;
  readonly pageLayoutTab: ITabDefinition = FormatEditor.Tabs.pageLayout;

  created(): void {
    this.initializeTabs();
  }

  get isPageLayoutTabActive(): boolean {
    return (this.selectedTab === this.pageLayoutTab);
  }

  initializeTabs(): void {
    this.tabs = [
      this.formatTab,
      this.isQuestionnaireEditable ? null : this.pageListTab,
      this.pageLayoutTab,
    ].filter(t => !!t);
    this.selectedTab = this.pageLayoutTab;
  }

  $refs!: {
    pageEditor: FormatPageEditor;
    commonComponents: CommonComponentsContainer;
  };

  get gridSize(): Size {
    return new Size(10, 10); // 設定やUIから取れるようになる場合はここで返すものを変える事.
  }

  get leftSideContents(): { [key: string]: any }[] {
    return [
      FormatToolContainer.Tabs.edit,
      FormatToolContainer.Tabs.currentPage,
      FormatToolContainer.Tabs.objectList,
      FormatToolContainer.Tabs.nameWarning,
//      FormatToolContainer.Tabs.schema,        // TODO: E大必須ではないので一旦非表示に.必要なら復活させて対応する事.
    ];
  }

  get rightSideContents(): { [key: string]: any }[] {
    return [
      FormatToolContainer.Tabs.createdFormat,
      FormatToolContainer.Tabs.alert,
      FormatToolContainer.Tabs.debug,
    ];
  }

  get pageListLeftSideContents(): { [key: string]: any }[] {
    return [
      FormatToolContainer.Tabs.page,
      FormatToolContainer.Tabs.backgroundImage,
      FormatToolContainer.Tabs.newPage,
    ];
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  complementFormatStructure() {
    if (this.isQuestionnaireEditable) {
      this.writePropertyWhenValid((s: FormatStructureEditor) => s.sortByLocation());
    }
  }
}
